import {
    Avatar,
    Box,
    CircularProgress,
    Paper,
    Tooltip,
    Typography,
} from '@mui/material';
import React from 'react';
import './RelationshipTree.css';
import _ from 'lodash';
import { useSelector } from 'react-redux';

const RelationshipTree = props => {
    const loading = useSelector(state => state?.backdrop?.progress);

    const NODES = [
        {
            id: '0',
            gender: 'female',
            relationship: 'Father',
            name: 'Name 1',
            parents: [{ id: '0', type: 'blood' }],
            siblings: [],
            spouses: [],
            children: [],
        },
        {
            id: '2',
            gender: 'female',
            relationship: 'Father',
            name: 'Name 2',
            parents: [{ id: '0', type: 'blood' }],
            siblings: [],
            spouses: [],
            children: [],
        },
        {
            id: '3',
            gender: 'female',
            relationship: 'Father',
            name: 'Name 3',
            parents: [{ id: '0', type: 'blood' }],
            siblings: [],
            spouses: [],
            children: [],
        },
        {
            id: '4',
            gender: 'female',
            relationship: 'Father',
            name: 'Name 4',
            parents: [{ id: '0', type: 'blood' }],
            siblings: [],
            spouses: [],
            children: [],
        },
        {
            id: '5',
            gender: 'female',
            relationship: 'Father',
            name: 'Name 5',
            parents: [{ id: '0', type: 'blood' }],
            siblings: [],
            spouses: [],
            children: [],
        },
    ];

    return (
        <>
            {/* <Box p={2}>
                <Paper elevation={2} sx={{ padding: '20px' }}>
                    <Typography
                        mb={2}
                        color={'primary'}
                        sx={{ fontWeight: '500' }}
                    >
                        Relationship Tree
                    </Typography>
                    <Grid container>
                        <Grid
                            item
                            xs={3}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            sdf
                        </Grid>
                    </Grid>
                </Paper>
            </Box> */}
            <Box p={2}>
                <Paper
                    elevation={2}
                    sx={{
                        padding: '20px',
                    }}
                >
                    <Typography
                        mb={2}
                        color={'primary'}
                        sx={{ fontWeight: '500' }}
                    >
                        Relationship Tree
                    </Typography>
                    {(!loading && (
                        <Box className="tree">
                            <ul>
                                <li>
                                    <div>
                                        <Box
                                            sx={{
                                                height: '10px',
                                                backgroundColor: '#387CA3',
                                                borderTopLeftRadius: '5px',
                                                borderTopRightRadius: '5px',
                                            }}
                                        />
                                        <Box
                                            py={2}
                                            px={1}
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                // maxWidth: '200px',
                                                // maxHeight:'126px',
                                                height: '120px',
                                                width: '100px',
                                                border: '1px solid #ccc',
                                                borderTop: 'none',
                                                borderBottomLeftRadius: '5px',
                                                borderBottomRightRadius: '5px',
                                            }}
                                        >
                                            <Avatar
                                                mt={2}
                                                sx={{
                                                    width: '25px',
                                                    height: '25px',
                                                    fontSize: '10px',
                                                }}
                                            >
                                                {props?.relatedpersonObject?.name?.[0]?.given?.[0]?.[0]?.toUpperCase()}
                                            </Avatar>
                                            <Tooltip
                                                title={
                                                    props?.relatedpersonObject
                                                        ?.name?.[0]?.text
                                                }
                                            >
                                                <Typography
                                                    my={2}
                                                    color={'primary'}
                                                    sx={{
                                                        fontWeight: '500',
                                                        fontSize: '10pt',
                                                    }}
                                                >
                                                    {props?.relatedpersonObject
                                                        ?.name?.[0]?.text
                                                        ?.length > 10
                                                        ? props?.relatedpersonObject?.name?.[0]?.text?.slice?.(
                                                              0,
                                                              9
                                                          ) + '...'
                                                        : props
                                                              ?.relatedpersonObject
                                                              ?.name?.[0]?.text}
                                                </Typography>
                                            </Tooltip>
                                            {/* <Typography color={'textSecondary'}>Mother, Aunt, Advocate</Typography> */}
                                        </Box>
                                    </div>
                                    <ul>
                                        {(props?.relations?.length > 0 &&
                                            props?.relations?.map(
                                                (item, index) => (
                                                    <li key={index}>
                                                        <Box
                                                            // px={2}
                                                            py={1}
                                                            bgcolor={
                                                                item?.raw
                                                                    ?.active
                                                                    ? '#387CA3'
                                                                    : '#8080808a'
                                                            }
                                                            color={'white'}
                                                            sx={{
                                                                border: 'none !important',
                                                                width: '100px',
                                                            }}
                                                        >
                                                            <Tooltip
                                                                title={_.capitalize(
                                                                    item?.relationType
                                                                )}
                                                            >
                                                                <Typography
                                                                    variant="contained"
                                                                    fontSize={
                                                                        // '16px'
                                                                        '10pt'
                                                                    }
                                                                >
                                                                    {item
                                                                        ?.relationType
                                                                        ?.length >
                                                                    10
                                                                        ? _.capitalize(
                                                                              item?.relationType?.slice(
                                                                                  0,
                                                                                  9
                                                                              ) +
                                                                                  '...'
                                                                          )
                                                                        : _.capitalize(
                                                                              item?.relationType
                                                                          )}
                                                                </Typography>
                                                            </Tooltip>
                                                        </Box>
                                                        <ul>
                                                            <li>
                                                                <div>
                                                                    <Box
                                                                        sx={{
                                                                            height: '10pt',
                                                                            backgroundColor: `${
                                                                                item
                                                                                    ?.raw
                                                                                    ?.active
                                                                                    ? '#387CA3'
                                                                                    : '#8080808a'
                                                                            }`,
                                                                            borderTopLeftRadius:
                                                                                '5px',
                                                                            borderTopRightRadius:
                                                                                '5px',
                                                                        }}
                                                                    />
                                                                    <Box
                                                                        py={2}
                                                                        px={1}
                                                                        sx={{
                                                                            display:
                                                                                'flex',
                                                                            flexDirection:
                                                                                'column',
                                                                            alignItems:
                                                                                'center',
                                                                            width: '100px',
                                                                            // height: '150px',
                                                                            // maxHeight:'126px',
                                                                            border: '1px solid #ccc',
                                                                            borderTop:
                                                                                'none',
                                                                            borderBottomLeftRadius:
                                                                                '5px',
                                                                            borderBottomRightRadius:
                                                                                '5px',
                                                                            // width: '200px',
                                                                        }}
                                                                    >
                                                                        <Avatar
                                                                            mt={
                                                                                2
                                                                            }
                                                                            sx={{
                                                                                width: '25px',
                                                                                height: '25px',
                                                                                fontSize:
                                                                                    '10px',
                                                                            }}
                                                                        >
                                                                            {item?.relatedTo?.display?.[0]?.toUpperCase()}
                                                                        </Avatar>
                                                                        <Tooltip
                                                                            title={
                                                                                item
                                                                                    ?.relatedTo
                                                                                    ?.display
                                                                            }
                                                                        >
                                                                            <Typography
                                                                                my={
                                                                                    2
                                                                                }
                                                                                color={
                                                                                    item
                                                                                        ?.raw
                                                                                        ?.active
                                                                                        ? 'primary'
                                                                                        : 'textSecondary'
                                                                                }
                                                                                sx={{
                                                                                    fontWeight:
                                                                                        '500',
                                                                                    fontSize:
                                                                                        '10pt',
                                                                                }}
                                                                            >
                                                                                {item
                                                                                    ?.relatedTo
                                                                                    ?.display
                                                                                    ?.length >
                                                                                10
                                                                                    ? item?.relatedTo?.display?.slice(
                                                                                          0,
                                                                                          9
                                                                                      ) +
                                                                                      '...'
                                                                                    : item
                                                                                          ?.relatedTo
                                                                                          ?.display}
                                                                            </Typography>
                                                                        </Tooltip>
                                                                        {/* <Typography color={'textSecondary'}>Mother, Aunt, Advocate</Typography> */}
                                                                    </Box>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </li>
                                                )
                                            )) || (
                                            <li>
                                                <Box
                                                    px={2}
                                                    py={1}
                                                    bgcolor={'#387CA3'}
                                                    color={'white'}
                                                    sx={{
                                                        border: 'none !important',
                                                    }}
                                                >
                                                    <Typography
                                                        variant="contained"
                                                        fontSize={'16px'}
                                                    >
                                                        No Relation Found
                                                    </Typography>
                                                </Box>
                                            </li>
                                        )}
                                    </ul>
                                </li>
                            </ul>
                        </Box>
                    )) || <>Loading...</>}
                </Paper>
            </Box>
        </>
    );
};

export default RelationshipTree;
